import { deleteData, getData, postData, putData } from "./APIServiceInterface";

export const getModelsService = async () => {
  const response = await getData("maintenance/model/get");
  return response;
};

export const createNewModelService = async (payload) => {
  const response = await putData("maintenance/model/create", payload);
  return response;
};

export const saveModelService = async (payload) => {
  return await postData("maintenance/model/update", payload);
};

export const deleteModelService = async (payload) => {
  return await deleteData("maintenance/model/delete", payload);
};

// Replaceable Text
export const createRepTextService = async (payload) => {
  return await putData("maintenance/replaceableText/create", payload);
};

export const saveRepTextService = async (payload) => {
  return await postData("maintenance/replaceableText/update", payload);
};

export const deleteRepTextService = async (payload) => {
  return await deleteData("maintenance/replaceableText/delete", payload);
};

export const getRegionsService = async () => {
  return await getData("maintenance/region/get");
};

export const sortMoelService = async (payload) => {
  return await postData("maintenance/replaceableText/updateMultiple", payload);
};

export const copySequenceInModel = async (payload) => {
  return await postData("maintenance/CopyReplaceableTxt", payload);
};


export const getModelBlockConfig = async (id="") => {
  return await getData(`ModelConfiguration/GetModelConfigurationStatusById?id=${id}`)
}

export const createUpdateModelBlockConfig = async (id, payload) =>{
  if(id){
    return await putData(`ModelConfiguration/UpdateModelConfiguration?id=${id}`, payload)
  }else{
    return await postData(`ModelConfiguration/CreateModelConfiguration`, payload)
  }
}